import React, { useEffect, useState } from "react";
import { AffiliateDashboardData } from "../../../network/api/AffiliateDashboardData";
import { AffiliateUsersData } from "../../../network/api/AffiliateUsersData";
import Toast from "../../../../../../../components/Toast";
import Pagination from "../../../../../../../components/Pagination";
import { highlightText } from "../../../../../../../utils/highlight";
import { Link } from "react-router-dom";
import { encodeId } from "../../../../../../../utils/hash";

export default function Dashboard({ userId, setIsUserPartner }) {

    const [isDashLoading, setIsDashLoading] = useState(false);
    const [isUsersLoading, setIsUsersLoading] = useState(false);

    const [dashData, setDashData] = useState(null);
    const [usersData, setUsersData] = useState([]);

    const [toastConfig, setToastConfig] = useState({
        visible: false,
        message: "",
        type: "primary",
    });

    const [pageProps, setPageProps] = useState({
        page: 1,
        totalPages: 1,
        totalEntries: 0,
        entryLimit: 0,
        visiblePages: []
    });

    const [pageFilters, setPageFilters] = useState({
        page: null,
        owner: userId,
        limit: 10
    });

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pageProps.totalPages) {
            setPageProps((prev) => ({
                ...prev,
                page: page,
            }));

            setPageFilters((prev) => ({
                ...prev,
                page: page,
            }));
        }

    };

    const handleLimitChange = (value) => {
        setPageFilters((prev) => ({
            ...prev,
            limit: value,
        }));

    };

    const [searchValue, setSetchValue] = useState(null);
    const handleSerchChange = (e) => {
        e.preventDefault();
        const { value } = e.target;
        setSetchValue(value);

        if (value.length >= 3) {
            setPageFilters((prev) => ({
                ...prev,
                page: null,
                fullname: value,
                displayname: value,
                email: value,
                phone: value,


            }));
        }

        if (value.length === 0) {
            setPageFilters((prev) => ({
                ...prev,
                page: null,
                fullname: null,
                displayname: null,
                email: null,
                phone: null,
            }));
        }

    }

    useEffect(() => {
        const fetchDashboardData = async () => {
            try {
                setIsDashLoading(true);
                const response = await AffiliateDashboardData({ owner: userId });
                if (response.status === "success") {
                    setIsUserPartner(true);
                    setDashData(response.data);
                } else {
                    if (response.code === 404) {
                        setIsUserPartner(false);
                    } else {
                        setToastConfig({
                            visible: true,
                            message: response.message || "Failed to fetch dashboard data.",
                            type: "danger",
                        });
                    }
                }
            } catch (error) {
                setToastConfig({
                    visible: true,
                    message: "An error occurred while fetching dashboard data.",
                    type: "danger",
                });
            } finally {
                setIsDashLoading(false);
            }
        };
        fetchDashboardData();
    }, [userId, setIsUserPartner]);

    useEffect(() => {
        const fetchUsersData = async () => {
            try {
                setIsUsersLoading(true);
                const response = await AffiliateUsersData({ pageFilters: pageFilters });
                if (response.status === "success") {
                    // Process users data if needed
                    setUsersData(response.data.data);
                    //console.log(response.data);
                    setPageProps({
                            page: response.data.page,
                            totalPages: response.data.total_pages,
                            totalEntries: response.data.total_records,
                            entryLimit: response.data.limit,
                            visiblePages: response.data.visible_pages,
                        })
                } else {
                    setToastConfig({
                        visible: true,
                        message: response.message || "Failed to fetch users data.",
                        type: "danger",
                    });
                }
            } catch (error) {
                setToastConfig({
                    visible: true,
                    message: "An error occurred while fetching users data.",
                    type: "danger",
                });
            } finally {
                setIsUsersLoading(false);
            }
        };
        fetchUsersData();
    }, [pageFilters]);

    if (isDashLoading) {
        return (
            <div className="container-fluid" key={`dashboard-loading-${userId}`}>
                <div className="row justify-content-center align-items-center" style={{ height: "80vh" }}>
                    <div className="col-auto text-center">
                        <div className="spinner-border text-primary mb-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="text-muted">Loading dashboard data, please wait...</p>
                    </div>
                </div>
            </div>
        );
    }
    const handleCopy = () => {
        const input = document.getElementById("referral-link-input");
        if (input) {

            navigator.clipboard.writeText(input.value)
                .then(() => setToastConfig({ visible: true, message: "Link copied to clipboard!", type: "success" }))
                .catch(() => setToastConfig({ visible: true, message: "Failed to copy link.", type: "danger" }));
        }
    };
    return (
        <div className="container-fluid" key={`dashboard-${userId}`}>
            <Toast message={toastConfig.message}
                type={toastConfig.type}
                visible={toastConfig.visible}
                setVisible={(visible) => setToastConfig({ ...toastConfig, visible })}
            />
            <div className="row">
                <div className="col-12 col-lg-6">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h4 className="card-title">Welcome to Your Partner Dashboard</h4>
                            <p className="card-text">Here you can track your users, earnings, and manage your partner account.</p>
                            <p className="card-text">Share your partner link to invite new users and earn commissions on their purchases.</p>
                            <p className="card-text">Your unique partner link:</p>
                            <div className="input-group mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="referral-link-input"
                                    value={`${window.location.origin}/register/${dashData?.referral_code ? dashData?.referral_code : ""}`}
                                    readOnly
                                />
                                <button
                                    className="btn btn-outline-primary"
                                    type="button"
                                    id="button-addon2"
                                    onClick={handleCopy}
                                >
                                    <i className="fas fa-copy"></i> Copy Link
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-6">

                    <div className="row">
                        <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-6">
                            <div className="widget-stat card">
                                <div className="card-body p-4">
                                    <div className="media ai-icon">
                                        <span className="me-3 bgl-primary text-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user">
                                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                                <circle cx="12" cy="7" r="4"></circle>
                                            </svg>
                                        </span>
                                        <div className="media-body">
                                            <p className="mb-1">Durect Users</p>
                                            <h4 className="mb-0">{dashData?.direct_users || 0}</h4>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-6">
                            <div className="widget-stat card">
                                <div className="card-body p-4">
                                    <div className="media ai-icon">
                                        <span className="me-3 bgl-success text-success">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-dollar-sign">
                                                <line x1="12" y1="1" x2="12" y2="23"></line>
                                                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                                            </svg>
                                        </span>
                                        <div className="media-body">
                                            <p className="mb-1">Balance</p>
                                            <h4 className="mb-0">{dashData?.balance || 0}</h4>

                                        </div>
                                    </div>

                                    <div className="text-end mt-3">
                                        <Link to={`/earnings/${userId ? encodeId(userId) : ""}?page=${encodeId(67788776)}`} className="btn btn-outline-success btn-sm px-4 rounded-pill" onClick={() => setToastConfig({ visible: true, message: "Withdrawal feature coming soon!", type: "info" })}>
                                            <i className="fas fa-arrow-down me-2"></i> Withdraw
                                        </Link>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="col-xl-6 col-xxl-6 col-lg-12 col-sm-6">
                            <div className="widget-stat card bg-warning">
                                <div className="card-body p-4">
                                    <div className="media">
                                        <span className="me-3">
                                            <i className="fa fa-hourglass-half text-white"></i>
                                        </span>
                                        <div className="media-body text-white text-end">
                                            <p className="mb-1">Pending Payouts</p>
                                            <h3 className="text-white">${dashData?.pending_payouts || 0}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-6 col-xxl-6 col-lg-12 col-sm-6">
                            <div className="widget-stat card bg-danger">
                                <div className="card-body p-4">
                                    <div className="media">
                                        <span className="me-3">
                                            <i className="fa fa-money-bill-wave text-white"></i>
                                        </span>
                                        <div className="media-body text-white text-end">
                                            <p className="mb-1">Total Earnings</p>
                                            <h3 className="text-white">${dashData?.earnings || 0}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-xl-12 col-xxl-12">
                    <h1 className="m-4">My Mentors</h1>

                    <div className="custom-card card">

                        <div className="card-body">
                            <div id="guestTable-all-1_wrapper" className="table-responsive dataTables_wrapper no-footer ">
                                <div className="dataTables_length" id="page_limit">
                                    <label>
                                        Show{" "}
                                        <select
                                            name="page_limit"
                                            aria-controls="example3"
                                            className=""
                                            value={pageProps.entryLimit}
                                            onChange={(e) => handleLimitChange(Number(e.target.value))}
                                        >
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>{" "}
                                        entries
                                    </label>
                                </div>
                                <div id="example3_filter" className="dataTables_filter">
                                    <label>
                                        Search:
                                        <input
                                            type="search"
                                            className=""
                                            placeholder=""
                                            aria-controls="example3"
                                            onChange={handleSerchChange}
                                        />
                                    </label>
                                </div>
                                <table className="table ">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>User</th>
                                            <th>Email</th>
                                            <th>Date Joined</th>
                                            <th>Status</th>
                                            <th>Users</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isUsersLoading && (
                                            <tr>
                                                <td colSpan="6" className="text-center">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        {!isUsersLoading && usersData.length === 0 && (
                                            <tr>
                                                <td colSpan="6" className="text-center py-5">
                                                    <div className="d-flex flex-column align-items-center justify-content-center text-muted">
                                                        <i className="fa fa-folder-open fa-3x mb-3"></i>
                                                        <p className="mb-0">No users found</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        {usersData && usersData?.map((user,index) => (
                                            <tr key={`dash-user-${index}`}>
                                                <td>{index+1}</td>
                                                <td className="d-flex align-items-center">
                                                    <img
                                                        src={user.image || "https://static.vecteezy.com/system/resources/previews/001/840/612/non_2x/picture-profile-icon-male-icon-human-or-people-sign-and-symbol-free-vector.jpg"}
                                                        alt={user.displayname}
                                                        className="rounded-circle me-2"
                                                        style={{ width: "40px", height: "40px", objectFit: "cover" }}
                                                        onError={(e) => { e.target.src = "https://static.vecteezy.com/system/resources/previews/001/840/612/non_2x/picture-profile-icon-male-icon-human-or-people-sign-and-symbol-free-vector.jpg"}}
                                                    />
                                                    <div>
                                                        <div className="fw-bold">{highlightText(user?.displayname, searchValue)}</div>
                                                        <div className="text-muted small">{highlightText(user?.fullname, searchValue)}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>{highlightText(user?.email, searchValue)}</div>
                                                    <div className="text-muted small">{highlightText(user?.phone, searchValue)}</div>
                                                </td>
                                                <td>{new Date(user.created).toLocaleDateString()}</td>
                                                <td>
                                                    <span className={`badge badge-rounded ${user.status === "active" ? "badge-success" : user.status === "pending" ? "badge-warning":"badge-danger"}`}>
                                                        {user.status.charAt(0).toUpperCase() + user.status.slice(1)}
                                                    </span>
                                                </td>
                                                <td>{user.total_referrals || 0}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <Pagination
                                    pageProps={pageProps}
                                    onPageChange={handlePageChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}